import {
  BulkUpdateDocument,
  BulkUpdateDocuments,
  BulkUpdateJob,
  BulkUpdateResult,
  BulkUpdateStatus,
} from 'models';
/**
 * Converts an S9ApiBulkUpdateDocumentDefinition object to a BulkUpdateJob Object.
 *
 * @param apiBulkUpdateDocument - BulkUpdateDocument from api call.
 * @returns - Converted BulkUpdateJob object.
 */
export const createBulkUpdateDocumentFromApi = (
  apiBulkUpdateDocument: S9ApiBulkUpdateDocumentDefinition
): BulkUpdateDocument => ({
  id: apiBulkUpdateDocument.Id,
  archiveId: apiBulkUpdateDocument.ArchiveId,
});
/**
 * Create a Bulk object from its API equivalent.
 *
 * @param S9ApiBulkUpdateDocuments - BulkUpdateDocument from api call.
 * @returns A BulkUpdateDocuments object.
 */
export const createBulkUpdateDocumentsFromApi = (
  S9ApiBulkUpdateDocuments: S9ApiBulkUpdateDocumentsDefinition
): BulkUpdateDocuments =>
  S9ApiBulkUpdateDocuments.map(createBulkUpdateDocumentFromApi);
/**
 * Converts an S9ApiBulkUpdateJobDefinition object to a BulkUpdateJob Object.
 *
 * @param apiBulkUpdateJob - BulkUpdateJob from api call.
 * @returns - Converted BulkUpdateJob object.
 */
export const createBulkUpdateJobFromApi = (
  apiBulkUpdateJob: S9ApiBulkUpdateJobDefinition
): BulkUpdateJob => ({
  databaseId: apiBulkUpdateJob.DatabaseId,
  documents: createBulkUpdateDocumentsFromApi(apiBulkUpdateJob.Documents),
  id: apiBulkUpdateJob.Id,
  status: createBulkUpdateStatusFromApi(apiBulkUpdateJob.Status),
});

/**
 * Converts an S9ApiBulkUpdateResultDefinition object to a BulkUpdateResult Object.
 *
 * @param apiBulkUpdateResult - BulkUpdateResult from api call.
 * @returns - Converted BulkUpdateResult object.
 */
export const createBulkUpdateResultFromApi = (
  apiBulkUpdateResult: S9ApiBulkUpdateResultDefinition
): BulkUpdateResult => ({
  errorMessages: apiBulkUpdateResult.ErrorMessages,
  erroredRows: apiBulkUpdateResult.ErroredRows,
  totalRows: apiBulkUpdateResult.TotalRows,
  updatedRows: apiBulkUpdateResult.UpdatedRows,
});

/**
 * Converts an S9ApiBulkUpdateStatusDefinition object to a BulkUpdateStatus Object.
 *
 * @param apiBulkUpdateStatus - BulkUpdateStatus from api call.
 * @returns - Converted BulkUpdateStatus object.
 */
export const createBulkUpdateStatusFromApi = (
  apiBulkUpdateStatus: S9ApiBulkUpdateStatusDefinition
): BulkUpdateStatus => ({
  cancelled: apiBulkUpdateStatus.Cancelled,
  currentRow: apiBulkUpdateStatus.CurrentRow,
  done: apiBulkUpdateStatus.Done,
  erroredRows: apiBulkUpdateStatus.ErroredRows,
  updatedRows: apiBulkUpdateStatus.UpdatedRows,
  progress: apiBulkUpdateStatus.Progress,
  started: apiBulkUpdateStatus.Started,
  totalRows: apiBulkUpdateStatus.TotalRows,
});
/**
 * An Array of S9ApiBulkUpdateDocumentsDefinition objects.
 *
 * @see S9ApiBulkUpdateDocumentsDefinition
 */
export declare type S9ApiBulkUpdateDocumentsDefinition =
  S9ApiBulkUpdateDocumentDefinition[];

/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable jsdoc/require-jsdoc */
export interface S9ApiBulkUpdateJobDefinition {
  ArchiveIds: number[];
  DatabaseId: string;
  Documents: S9ApiBulkUpdateDocumentDefinition[];
  Id: string;
  Status: S9ApiBulkUpdateStatusDefinition;
}

export interface S9ApiBulkUpdateDocumentDefinition {
  Id: number;
  ArchiveId: number;
}

export interface S9ApiBulkUpdateResultDefinition {
  ErrorMessages: string[];
  ErroredRows: number;
  TotalRows: number;
  UpdatedRows: number;
}

export interface S9ApiBulkUpdateStatusDefinition {
  Cancelled: boolean;
  CurrentRow: number;
  Done: boolean;
  ErroredRows: number;
  UpdatedRows: number;
  Progress: number;
  Started: boolean;
  TotalRows: number;
}
